import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { ServerStatusType } from "../../utils";

export const StatusActiveDropDown = ({
  value,
  isMulti = false,
  isShowAll = true,
  onSelect,
  placeholder,
  className = "",
  ...props
}) => {
  const [list, setList] = useState();

  useEffect(() => {
    const statusValues = [
      { id: 1, label: "Active", value: ServerStatusType.active },
      { id: 2, label: "Inactive", value: ServerStatusType.inactive },
      { id: 3, label: "Semi Active", value: ServerStatusType.semiactive },
    ];

    if (isShowAll) {
      const allOption = { id: 0, label: "All", value: "" };
      setList([allOption, ...statusValues]);
    } else {
      setList(statusValues);
    }
  }, [isShowAll]);

  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      className={`w-120px ${className}`.trim()}
      value={value ?? (isShowAll ? (list ? list[1] : null) : null)}
      onChange={(e) => {
        onSelect(e);
      }}
      {...props}
    />
  );
};
